export default {
  'get-list': {
    method: 'post',
    url: '/ws-admincp/business/task/list'
  },
  getById: {
    method: 'get',
    url: '/ws-admincp/business/task/ID'
  },
  delete: {
    method: 'delete',
    url: '/ws-admincp/business/task'
  },
  archive: {
    method: 'delete',
    url: '/ws-admincp/business/task/archive'
  },
  restore: {
    method: 'put',
    url: '/ws-admincp/business/task/restore'
  },
  add: {
    method: 'post',
    url: '/ws-admincp/business/task'
  },
  edit: {
    method: 'put',
    url: '/ws-admincp/business/task/ID'
  },
  select: {
    method: 'get',
    url: '/ws-admincp/business/task/find?key=KEY&taskType=TASKTYPE'
  }
}
